import React, { FC } from 'react';
import { Link } from 'react-router-dom';



import './Home-Cards.css';
interface HomeCardsProps { }
const HomeCards: FC<HomeCardsProps> = () => (
    <div className="HomeCards">
        <div className="pds-card pds-card-active pds-card-square home-card">
  <div className="pds-card-active-section d-flex justify-content-center home-container-card-1">
  </div>
  <div className="pds-card-section home-card-section-1">
  <div className="content-text-1">
        <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">
          <Link to="/new-repository"><h2 className='pds-card-title home-card-title-1'>Nuevo Repositorio</h2></Link>
        </a>
        <p>En esta sección, podrás solicitar la generación de un nuevo repositorio.</p>
    </div>
  </div>
</div>

<div className="pds-card pds-card-active pds-card-square home-card">
  <div className="pds-card-active-section d-flex justify-content-center home-container-card-2">
  </div>
  <div className="pds-card-section home-card-section-2">
  <div className="content-text-2">
        <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">
          <Link to="/repositories"><h2 className='pds-card-title home-card-title-2'>Acceso a Repositorios</h2></Link>
        </a>
        <p>En esta sección, podrás solicitar acceso a los repositorios disponibles.</p>
    </div>
  </div>
</div>

<div className="pds-card pds-card-active pds-card-square home-card">
  <div className="pds-card-active-section d-flex justify-content-center home-container-card-3">
  </div>
  <div className="pds-card-section home-card-section-3 ">
  <div className="content-text-3">
        <a data-gtm="navigation-primary" href="#" className="pds-link-unstyled">
          <Link to="/my-repositories"><h2 className='pds-card-title home-card-title-3'>Mis Repositorios</h2></Link>
        </a>
        <p>En esta sección, podrás revisar tus repositorios, y ver en detalle el contenido.</p>
    </div>
  </div>
</div>
{/* <div className="pds-card pds-card-active pds-card-square home-card">
  <div className="pds-card-active-section d-flex justify-content-center home-container-card-4">
  </div>
  <div className="pds-card-section home-card-section-4">
  <div className="content-text-4">
        <Link to="/admin-repositories">
            <h2 className='pds-card-title home-card-title-4'>Administracion de Repositorios</h2>
        </Link>
        <p>En esta seccion, podras revisar las solicitudes generadas por los usuarios.</p>
    </div>
  </div>
</div> */}
</div>


);

export default HomeCards;